if (typeof define === "function" && define.amd) {
    define('main',['Controls/Ready', 'jquery'], function (Ready) {
        //Определение браузера----------------------------------------------------------------
        var BrowserDetect = {
            init: function() {
                this.browser = this.searchString(this.dataBrowser) || "An unknown browser";
                this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "an unknown version";
                this.OS = this.searchString(this.dataOS) || "an unknown OS";
            },
            searchString: function(data) {
                for (var i = 0; i < data.length; i++) {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;
                    this.versionSearchString = data[i].versionSearch || data[i].identity;
                    if (dataString) {
                        if (dataString.indexOf(data[i].subString) != -1)
                            return data[i].identity;
                    } else if (dataProp)
                        return data[i].identity;
                }
            },
            searchVersion: function(dataString) {
                var index = dataString.indexOf(this.versionSearchString);
                if (index == -1) return;
                return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            },
            dataBrowser: [{
                string: navigator.vendor,
                subString: "Apple",
                identity: "Safari",
                versionSearch: "Version"
            }, {
                string: navigator.userAgent,
                subString: "Trident",
                identity: "Internet Explorer",
                versionSearch: "rv"
            }, {
                string: navigator.userAgent,
                subString: "Gecko",
                identity: "Mozilla",
                versionSearch: "rv"
            }, {
                /* For Older Netscapes (4-) */
                string: navigator.userAgent,
                subString: "Mozilla",
                identity: "Netscape",
                versionSearch: "Mozilla"
            }],
            dataOS: [{
                string: navigator.platform,
                subString: "Win",
                identity: "Windows"
            }, {
                string: navigator.platform,
                subString: "Mac",
                identity: "Mac"
            }, {
                string: navigator.userAgent,
                subString: "iPhone",
                identity: "iPhone"
            }, {
                string: navigator.platform,
                subString: "Linux",
                identity: "Linux"
            }]

        };

        function  lazyLoadsInit() {
            var $lazyLoads = $('.j-lazy-load');
            if ($lazyLoads.length > 0) {
                require(['jquery', 'Controls/LazyLoad'], function ($, LazyLoad) {
                    var obLazyLoad = new LazyLoad($lazyLoads);
                    obLazyLoad.init();
                });
            } else {
                $.event.trigger({
                    type: 'lazyLoadReceived',
                    data: []
                });
            }
        }

        function enableOnIphone() {
            BrowserDetect.init();
            if (BrowserDetect.OS.toLowerCase() === 'iphone' || BrowserDetect.OS.toLowerCase() === 'mac') {
                $("body,html").addClass("is-"+ BrowserDetect.OS.toLowerCase()).addClass("is-" + BrowserDetect.browser.toLowerCase());
            }
        }

        enableOnIphone();


        var compositeFinished;
        (function () {
            var df = $.Deferred();
            if (window.frameCacheVars !== undefined) {
                BX.addCustomEvent("onFrameDataReceived", function () {
                    df.resolve();
                });
            } else {
                df.resolve();
            }
            compositeFinished = function (fn) {
                if (typeof fn == 'function') df.done(fn);
                return df.promise();
            }
        })();

        function startOwlCarousel(context){
            $('.j-owl-carousel', context).each(function () {
                var item = $(this);
                require(['Controls/OwlCarousel2'], function (OwlCarousel2) {
                    new OwlCarousel2(item);
                });
            })
        };

        function startSpoiler(context) {
            var $spoiler = $('.j-spoiler', context);
            if ($spoiler.length) {
                $spoiler.each(function () {
                    var $item = $(this);
                    require(['Controls/Spoiler'], function (Spoiler) {
                        new Spoiler($item);
                    });
                });
            }
        }

        function startPopups(context) {
            var fancyboxGroup = $(".fancybox", context).add('[rel = prettyPhoto]', context).add('[rel = group]', context);
            if (fancyboxGroup.length > 0) {
                require(['fancybox'], function () {
                    fancyboxGroup.fancybox();
                });
            }
            var $fancybox = $('.j-fancybox', context);
            var $popupLink = $('.j-popup-link', context);

            if ($fancybox.length > 0 || $popupLink.length > 0) {
                require(['jquery', 'fancybox', 'cusel'], function ($) {
                    if ($fancybox.length > 0) {
                        $fancybox.fancybox({
                            padding: 40
                        });
                    }
                    if ($popupLink.length > 0) {
                        $popupLink.fancybox({
                            fitToView: false,
                            padding: 0,
                            arrows: false,
                            closeBtn: false,
                            afterLoad: function () {
                                $(".j-close").live("click", function () {
                                    $.fancybox.close(true);
                                });
                            },
                            afterShow: function () {
                                var id = '';
                                $('.fancybox-wrap .cusel input').each(function (i) {
                                    if (i != 0) id += ',';
                                    id += '#' + $(this).attr('id');
                                });
                                var params = {
                                    refreshEl: id,
                                    visRows: 6,
                                    scrollArrows: true
                                };
                                cuSelRefresh(params);
                            }
                        });
                    }
                });
            }
        };

        function startSelects() {
            if ($('.j-select').length) {
                require(['cusel'], function () {
                    var params = {
                        changedEl: ".j-select",
                        visRows: 6,
                        scrollArrows: true
                    };
                    try {
                        cuSel(params);
                    }catch (e) {
                        console.error(e.getMessage())
                    }

                    $(document).data('jSelectInit', true);
                    $(document).trigger("jSelect.init");
                });
            } else {
                $(document).data('jSelectInit', true);
                $(document).trigger("jSelect.init");
            }

            var $relatedSelects = $('.j-related-selects');
            if ($relatedSelects.length) {
                $(document).on("jSelect.init", function () {
                    $('.j-related-selects').each(function () {
                        var $item = $(this);
                        require(['Controls/RelatedSelects'], function (RelatedSelects) {
                            new RelatedSelects({
                                select1: $item
                            });
                        });
                    });
                });
            }
        };

        function textScrollStart() {
            var $textScroll = $('.j-text-scroll');
            if ($textScroll.length) {
                $textScroll.each(function () {
                    var $item = $(this);
                    require(['Controls/TextScroll'], function (TextScroll) {
                        new TextScroll($item);
                    });
                });
            }
        };

        function formStart(context) {
            var $formPopup = $('.j-form-popup', context);
            if ($formPopup.length) {
                $formPopup.each(function () {
                    var $item = $(this);
                    require(['Controls/Form/FormPopupMng'], function (FormPopupMng) {
                        var obFormPopup = new FormPopupMng({
                            root: $item
                        });
                        var globalName = obFormPopup.getGlobalName();
                        window[globalName] = obFormPopup;
                        obFormPopup.init();
                        $item.trigger("jFormPopup.init");
                    });
                });
            }

            var $formPage = $('.j-form-page', context);
            if ($formPage.length) {
                $formPage.each(function () {
                    var $item = $(this);
                    require(['Controls/Form/FormPageMng'], function (FormPageMng) {
                        var obFormPage = new FormPageMng({
                            root: $item
                        });
                        var globalName = obFormPage.getGlobalName();
                        window[globalName] = obFormPage;
                        obFormPage.init();
                        $item.trigger("jFormPage.init");
                    });
                });
            }
        };

        function startSwiper() {
            function swiperInitialize(selector, swiperObject, callback){
                require(['swiper'], function (Swiper) {
                    const Slider = new Swiper(selector, swiperObject);
                    if(callback && typeof callback === "function") callback(Slider);
                });
            }

            // Как мы можем вам помочь
            if($(".vector__swiper-container").length) {
                var swiperObject = {
                    slidesPerView: 1,
                    allowTouchMove: false,
                    simulateTouch: false,
                    effect: 'fade',
                    autoHeight: true,
                    initialSlide: 1,
                }

                swiperInitialize(".vector__swiper-container", swiperObject, function (vector) {
                    $('[data-vector-list] li').on('click', function () {
                        var index = $(this).index();

                        vector.slideTo(index);
                        $('[data-vector-list] li').removeClass('active');
                        $(this).addClass('active');
                    });

                    $('[data-vector-select]').click(function() {
                        const $list = $(this).siblings($('[data-vector-listm]'));
                        $list.toggleClass('closed');
                        $(this).toggleClass('closed');
                    });
                });

            }

            // также вас может заинтересовать
            if ($('.also__swiper-container').length) {
                var swiperObject = {
                    slidesPerView: 1,
                    allowTouchMove: true,
                    simulateTouch: true,
                    fadeEffect: {
                        crossFade: true
                    },
                    autoHeight: true,
                    pagination: {
                        clickable: true,
                        el: '.also__pagination',
                    },
                    breakpoints: {
                        600: {
                            allowTouchMove: false,
                            simulateTouch: false,
                        },
                    },
                };

                swiperInitialize('.also__swiper-container', swiperObject);

            }

            // вендоры
            if ( $('.vendor__swiper-container').length) {
                var swiperObject = {
                    slidesPerView: 2,
                    spaceBetween: 32,
                    navigation: {
                        disabledClass: 'vendor__swiper-button_disabled',
                        nextEl: '.vendor__swiper-button_next',
                        prevEl: '.vendor__swiper-button_prev',
                    },
                    breakpoints: {
                        200: {
                            slidesPerView: 1,
                        },
                        600: {
                            slidesPerView: 3,
                        },
                        1200: {
                            slidesPerView: 5,
                        },
                    },
                };

                swiperInitialize('.vendor__swiper-container', swiperObject);
            }

            // Блок о компании -----------------------------------
            if ($('.about__swiper-container').length) {
                var swiperObject = {
                    slidesPerView: 1,
                    allowTouchMove: true,
                    simulateTouch: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    autoHeight: true,
                    navigation: {
                        nextEl: '.about__navigation--next',
                        prevEl: '.about__navigation--prev',
                    },
                    pagination: {
                        clickable: true,
                        el: '.about__pagination',
                    },
                    breakpoints: {
                        600: {
                            allowTouchMove: false,
                            simulateTouch: false,
                        },
                    },
                };

                swiperInitialize('.about__swiper-container', swiperObject, function (about) {
                    $('[data-about-list] li').each(function(index) {
                        const $el = $(this);
                        $el.click(function() {
                            about.slideTo(index);
                            $('[data-about-list] li').removeClass('active');
                            $el.addClass('active');
                        });
                    });
                });

            }

        }


        // lazyload img
        requirejs(['lozad'], function (lozad) {
            var observer = lozad('.lozad', {
                rootMargin: `${window.innerHeight}px 0px ${window.innerHeight}px 0px`,
            });
            observer.observe();
        });

        $(function() {
            startSwiper();
        });

        if ($('#geo_confirm').length) {
            if (/Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() < 980){
                $('body').addClass('iti-mobile');
                $('body').prepend($('#geo_confirm'));
                $('body').append('<div class="fancybox-overlay fancybox-overlay-fixed geo-confirm-overlay"></div>');
                $(document).mouseup(function (e) {
                    var div = $("#geo_confirm");
                    if (!div.is(e.target) && div.has(e.target).length === 0) {
                        $('.geo-confirm-overlay').remove();
                        $('#geo_confirm').find('.close').click();
                    }
                });
                $('.j-city-popup').on('click', function () {
                    $('#geo_confirm').find('.close').click();
                });
                $('.confirm-btn').on('click', function () {
                    $('.geo-confirm-overlay').remove();
                });
                $('#geo_confirm .close').on('click', function () {
                    $('.geo-confirm-overlay').remove();
                });
            }
        }




        //Плавная прокрутка до якоря
        if($('.scanner-type').length) {
            $('.type').on('click', function(e){
                e.preventDefault();
                var destination = $(this).attr('href');
                var $target = $(destination).offset().top;
                $('html,body').stop().animate({ scrollTop: $target }, 1000);

            });
        }




        //Мероприятия для вашего развития---------------------
        if($('.events__video').length) {
            //Производим предварительную конвертацию путей
            var shortLinkAddress = $('.events__video').attr('data-href');
            var longLinkAddress = shortLinkAddress.replace("https://youtu.be/","https://www.youtube.com/embed/") + '?rel=0&autoplay=1';

            //Делаем подмену адресов
            $('.events__video').removeAttr('data-href');
            $('.events__video').attr('href', longLinkAddress);


            //Вызываем видео в модалке
            require(['fancybox'], function () {
                $('.events__video').fancybox(
                    {
                        type : 'iframe',
                        margin: 0,
                        padding: 5,
                        width : '80%',
                        height : '55%',
                        maxWidth : 640,
                        maxHeight : 480,
                        transitionIn: 'none',
                        transitionOut: 'none',
                        overlayShow : true,
                        centerOnScroll : true,
                        autoScale: true,
                        autoSize : true,
                        helpers: {
                            media : {},
                            overlay: {
                                locked: false
                            }
                        }
                    }
                );

            });
        }




        window.extend = function (Child, Parent) {
            var F = function () {
            };
            F.prototype = Parent.prototype;
            Child.prototype = new F();
            Child.prototype.constructor = Child;
            Child.superclass = Parent.prototype;
        }

         window.getInitial=function(el, defName, eventTrigger, dataTrigger) {
            if (!(el instanceof jQuery)) {
                throw new Error("Invalid argument - is not jquery object");
            }
            if (typeof defName == 'undefined') {
                defName = 'initDeferred';
            }
            var defer = el.data(defName);

            if (!defer) {
                defer = $.Deferred();
                el.data(defName, defer);
            }
            el.on(eventTrigger, function () {
                defer.resolve();
            });
            if (el.data(dataTrigger)) {
                defer.resolve();
            }
            return defer;
        }

        $(document).on("onMainInit", function (event) {

            var context = event.contextContainer;


            //Заполняем скрытый инпут форм
            var $sessid = $('form #sessid', context);
            if ($sessid.length > 0) {
                $sessid.val(BX.bitrix_sessid());
            }

            // lozad криво работает на сафари
            if(document.body.classList.contains('is-safari')){
                $("embed.lozad").each(function() {
                    $(this).removeClass('lozad');
                    $(this).attr({
                        src: $(this).attr('data-src')
                    }).removeAttr('data-src');
                });
            }

            /* Menu Actions */
            if($('.common-menu').length > 0){
              $( 'a.menu__link[data-toggle="dropdown"]' ).unbind().click(function(e) {
                e.stopPropagation(); e.preventDefault();
                if( $(this).parent('li.dropdown').hasClass('open') ){
                  $(this).parent('li.dropdown').removeClass('open');
                }else{
                $('.common-menu li.dropdown').each( function(){
                  if( $(this).hasClass('open') ){
                    $(this).removeClass('open');
                  }
                });

                $(this).parent('li.dropdown').addClass('open');
              }
            });

            $(document).on("click", function(event){
                if(!$(event.target).closest("li.dropdown").length){
                    $("li.dropdown").removeClass("open");
                }
            });
          }

            $(document).ready(function(){
               $('.header-row__search-link').unbind().click(function(e){
                e.preventDefault();
                $('.header-search-wrapper').slideToggle();
              });
            });
            setTimeout(function() {
                var i = $(".bit-floating-wrapper");
                i.addClass("sticky");
                $(".bit-menu__postfix-menu").height(i.height()).addClass("show");
                function e() {
                    var verticalOffset = window.pageYOffset;
                    if (verticalOffset > 0) {
                        $(".js-menu-main").addClass("menu-sticky");
                    } else {
                        $(".js-menu-main").removeClass("menu-sticky");
                    };
                }

                window.onscroll = e;

                $(window).on('resize', function(){
                    var i = $(".bit-floating-wrapper");
                    i.addClass("sticky");
                    $(".bit-menu__postfix-menu").height(i.height()).addClass("show");
                    var win = $(this);
                    if (win.width() >= 990) {
                        $('.menu__list').attr('style', '');
                        $('.biti-burger_blue').removeClass('active');
                    }
                });
            }, 500);


            $(function(){
                $('.biti-burger_blue').unbind().click(function(){
                    $('.biti-burger_blue').toggleClass('active');
                    $(".menu__list").slideToggle();
                    $('body').toggleClass('body-not-scroll');
                });
            });

            var $deffered = $('.j-deffered', context);
            if ($deffered.length > 0) {
                require(['Controls/DeferredDataMng'], function (DeferredDataMng) {
                    var obDeffered = new DeferredDataMng($deffered);
                    obDeffered.init();
                    context = $(context).add(obDeffered.items);
                    $(document).trigger("DeferredDataMng.init");
                });
            }

            /* End of Menu Actions */

            /*
             * Первый приоритет
             */
            var $navSide = $('.j-nav-side', context);
            if ($navSide.length > 0) {
                $navSide.each(function () {
                    var $item = $(this);
                    require(['Controls/NavSide'], function (NavSide) {
                        new NavSide($item);
                    });
                });
            }
            var $contactManager = $(".j-contact-manager", context);
            if ($contactManager.length > 0) {
                require(['Controls/Contact/ContactManagerSingle',
                    'Controls/Contact/ContactManager',
                    'Controls/Contact/ContactBox',
                    'Controls/Contact/AContactBoxView',
                    'Controls/Contact/ContactBoxView_1',
                    'Controls/Contact/ContactBoxView_2',
                    'Controls/Contact/ContactBoxView_3',
                    'Controls/Contact/ContactBoxView_4',
                    'Controls/Contact/ContactBoxView_n',
                    'tools/tools'], function (ContactManagerSingle) {
                    var obContactManager = ContactManagerSingle();
                    $contactManager.each(function () {
                        var $this = $(this);
                        var dataOffices = dataString2Json($this.data('offices'));
                        if (dataOffices instanceof Array) {
                            obContactManager.addData('office', dataOffices);
                            obContactManager.addData('allOffice', dataOffices);
                        }
                        var dataAllOffices = dataString2Json($this.data('allOffices'));
                        if (dataAllOffices instanceof Array) {
                            obContactManager.addData('allOffice', dataAllOffices);
                        }
                    });
                });
            }
            var $contactManagerFilter = $(".j-contact-manager-filter", context);
            if ($contactManagerFilter.length > 0) {
                require(['Controls/Contact/ContactManagerFilterPool',
                    'Controls/Contact/ContactManagerSingle',
                    'Controls/Contact/ContactManagerFilter',
                    'tools/tools'], function (ContactManagerFilterPool, ContactManagerSingle) {
                    var globalInstances = ['city', 'office'];
                    $contactManagerFilter.each(function () {
                        var $this = $(this);
                        for (var i in globalInstances) {
                            var instance = globalInstances[i];
                            var generalFilter = dataString2Json($this.data(instance + 'GeneralFilter'));
                            if (typeof generalFilter == 'object') {
                                var obContactManagerFilter = new ContactManagerFilterPool(instance);
                                obContactManagerFilter.setGeneral(generalFilter);
                            }
                        }
                    });
                    var obContactManager = ContactManagerSingle();
                    for (var i in globalInstances) {
                        var instance = globalInstances[i];
                        var obContactManagerFilter = new ContactManagerFilterPool(instance);
                        obContactManagerFilter.setContactManager(obContactManager);
                        if (obContactManagerFilter.dfSetGeneral.state() == 'pending') {
                            obContactManagerFilter.dfSetGeneral.resolve(obContactManagerFilter.obGeneralFilter);
                        }
                    }
                });
            }

            var $navCanvasMenu = $('nav#canvas-menu', context);
            if ($navCanvasMenu.length > 0) {
                require(['Controls/Responsive'], function (obResponsive) {
                    obResponsive.one(['xsmall', 'small', 'medium'], 'in', function () {
                        /**
                         * Side Меню
                         */
                        require(['mmenu'], function () {
                            require(['mmenu.navbars'], function () {
                                $navCanvasMenu.mmenu({
                                    "slidingSubmenus": false,
                                    "extensions": [
                                        "theme-dark",
                                        "border-none",
                                        "multiline"
                                    ],
                                    "offCanvas": {
                                        "position": "right",
                                        "zposition": "front"
                                    },
                                    "navbar": {
                                        "title": "Меню"
                                    },
                                    "navbars": [
                                        {
                                            "position": "top",
                                            "content": [
                                                "prev",
                                                "title",
                                                "close"
                                            ]
                                        }
                                    ]
                                });

								var api = $navCanvasMenu.data( "mmenu" );
								api.bind( "open", function() {
									$( "nav#canvas-menu li.mm-vertical" ).each(function( index ) {
										var lnk = $( this ).find("a.mm-next").data("target");
										$( this ).find("a.mm-sm_link").attr("href", lnk);
									});
								});
                            });
                        });
                    });
                });
            }
            var $slider1 = $('.j-slider1', context);
            if ($slider1.length > 0) {
                $slider1.each(function () {
                    var $item = $(this);
                    if ($item.closest('.nav-sub-content').length > 0) return;
                    require(['Controls/Slider1'], function (Slider1) {
                        new Slider1($item);
                    });
                });
            }

            startOwlCarousel(context);

            /*Отключение увеличения вьюпорта на айфонах*/

            if (/iPhone/.test(navigator.userAgent) && !window.MSStream)
            {
                $(document).on("focus", "input, textarea, select", function()
                {
                    $('meta[name=viewport]').remove();
                    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">');
                });

                $(document).on("blur", "input, textarea, select", function()
                {
                    $('meta[name=viewport]').remove();
                    $('head').append('<meta name="viewport" content="width=device-width, initial-scale=1">');
                });
            }


            $('.js-menu', context).each(function () {
                var item = $(this);
                require(['slinky'], function (slinky) {
                    $('.js-menu').slinky({
                        title: true
                    });
                });
            });


            var $switchText = $('.j-switch-text', context);
            if ($switchText.length > 0) {
                $switchText.each(function () {
                    var $item = $(this);
                    require(['Controls/SwitchText'], function (SwitchText) {
                        new SwitchText($item);
                        $item.trigger("jSwitchText.init");
                    });
                });
            }
            // добавляем отправку событий в Яндекс и Гугланалитику
            require(['Controllers/SeoTrackHelper'], function(SeoTrackHelper) {

                // window.Ya._metrika.counters
                let yandex_counter = window.yaCounter11881714;

                if (location.hostname.match('.kz') || (window.location.href.indexOf('kazakhstan') > -1)) {
                    yandex_counter = window.yaCounter46772403;
                }

                window.SeoTrackHelper = new SeoTrackHelper();
                window.SeoTrackHelper.counters = {
                    yandex: yandex_counter
                }

                window.SeoTrackHelper.goalsData = {
                    'send-callHunter':{
                        'yandex': {
                            code: 'callHunter-send'
                        },
                    },
                    'send-61POPUP-REG':{
                        'yandex': {
                            code: 'event-send'
                        },
                    },
                    'send-120':{
                        'yandex': {
                            code: 'vacancy-send'
                        },
                    },
                    'send-111':{
                        'yandex': {
                            code: 'vacancy-send'
                        },
                    },
                    'send-172SERVICE_ORD':{
                        'yandex': {
                            code: 'phonelead-send'
                        },
                    },
                    'send-115COMPLAINTS_HEADER':{
                        'yandex': {
                            code: 'complaintboss-send'
                        },
                    },
                    'send-173BLOG_SUBSCRIBE':{
                        'yandex': {
                            code: 'subscribed'
                        },
                    },
                    'send-173ACTIONS_SUBSCRIBE':{
                        'yandex': {
                            code: 'subscribed'
                        },
                    },
                    'send-default':{
                        'yandex': {
                            code: 'form-send'
                        },
                    }
                }
            });
            // результат заполнения popup формыб цель определяем по маркеру формы
            $(document).on("form.result.popup.open", function (event, resultArr) {
                if(!resultArr.error) {
                    window.SeoTrackHelper.sendGoal('send',resultArr.formSalt);
                }
            });

            formStart(context);

            /*
             * Второй приоритет
             * */
            if ($('.content iframe[src*="youtube.com"]', context).length > 0) {
                require(['Controls/Youtube'], function (Youtube) {
                    new Youtube($('.content', context));
                });
            }
            var $nav = $('.j-nav', context);
            if ($nav.length > 0) {
                $nav.each(function () {
                    var $item = $(this);
                    require(['Controls/Nav'], function (Nav) {
                        new Nav($item);
                    });
                });
            }
            var $dropdown = $('.j-dropdown', context);
            if ($dropdown.length > 0) {
                $dropdown.each(function () {
                    var $item = $(this);
                    require(['Controls/Dropdown'], function (Dropdown) {
                        new Dropdown($item);
                    });
                });
            }
            function initializeDifferentList() {
                var $differentItems = $('.j-city, .j-product', context);
                if ($differentItems.length > 0) {
                    var $dlContext = $('.width', context);
                    $differentItems.each(function () {
                        var $item = $(this);
                        require(['Controls/DifferentList'], function (DifferentList) {
                            new DifferentList($item, $dlContext);
                        });
                    });
                }
            }

            compositeFinished(function () {
                initializeDifferentList();
            });

            var $floating = $('.j-floating', context);
            if ($floating.length > 0) {
                require(['Controls/Responsive'], function (obResponsive) {
                    obResponsive.one(['large'], 'in', function () {
                        $floating.each(function () {
                            var $item = $(this);
                            require(['Controls/FloatingBox'], function (FloatingBox) {
                                new FloatingBox($item);
                            });
                        });
                    });
                });
            }

            /*Всё остальное*/

            require(['main'], function () {
                require(['Controls/Responsive'], function (obResponsive) {
                    if($('.about-block3').length) {
                        var timeLineSteps = $('.about-block3').find('.leaf');
                        if (timeLineSteps.length) {
                            var margins = [];
                            var currentStyle = "";
                            var currentOrientation = ""
                            timeLineSteps.each(function () {
                                currentStyle = (typeof $(this).attr("style") !== "undefined") ? $(this).attr("style").trim() : "margin-top: 0";
                                currentOrientation = ($(this).hasClass('leaf--left')) ? "leaf--left" : "leaf--right";
                                margins.push({
                                    "orientation" : currentOrientation,
                                    "attribute" : currentStyle
                                });
                            });
                            obResponsive.on(['large'], 'in', function () {
                                timeLineSteps.removeClass();
                                timeLineSteps.addClass('leaf');
                                timeLineSteps.each(function (index) {
                                    $(this).attr("style", margins[index].attribute);
                                    $(this).addClass(margins[index].orientation);
                                })

                            });
                            obResponsive.on(['xsmall', 'small', 'medium'], 'in', function () {
                                timeLineSteps.each(function () {
                                    $(this).removeAttr("style");
                                    $(this).removeClass('leaf--left');
                                    $(this).addClass('leaf--right');
                                })



                            });
                        }
                    };

                    var $tabItemSelector = $('.tab-item--default');

                    if ($tabItemSelector.length) {
                        obResponsive.on(['medium', 'large'], 'in', function () {
                            $tabItemSelector.off();
                        });

                        obResponsive.on(['xsmall', 'small'], 'in', function () {
                            $tabItemSelector.on('click', function(event) {
                                event.preventDefault();
                                $(this).siblings('.bit-tabs__nav').toggleClass('is-opened');
                            });

                        });
                    }

                    var $priceGridBlock = $('.price-grid__block');

                    if ($priceGridBlock.length) {
                        var maxHeight = 100;
                        var maxHeightSub = 0;
                        var maxHeightDesc = 0;

                        $(".price-grid__block").each(function () {
                            var thisH = $(this).find('.price-grid__title').height();
                            if (thisH > maxHeight) {
                                maxHeight = thisH;
                            }
                        });

                        $(".price-grid__title").height(maxHeight);


                        $(".price-grid__subtitle").each(function () {
                            var thisH = $(this).height();
                            if (thisH > maxHeightSub) {
                                maxHeightSub = thisH;
                            }
                        });
                        $(".price-grid__subtitle").height(maxHeightSub);


                        $(".price-grid__desc").each(function () {
                            var thisH = $(this).height();
                            if (thisH > maxHeightDesc) {
                                maxHeightDesc = thisH;
                            }
                        });
                        $(".price-grid__desc").height(maxHeightDesc);

                    }

                });
            });



            /*
             * Табы и навигация
             * */
            var $navHover = $('.j-nav-hover', context);
            if ($navHover.length > 0) {
                $navHover.each(function () {
                    var $item = $(this);
                    require(['Controls/NavHover'], function (NavHover) {
                        new NavHover($item);
                    });
                });
            }

            var $switch2 = $('.j-switch2', context);
            if ($switch2.length > 0) {
                $switch2.each(function () {
                    var $item = $(this);
                    require(['Controls/Switch2'], function (Switch2) {
                        new Switch2($item);
                    });
                });
            }

            var $switchMultiple = $('.j-switch-multiple', context);
            if ($switchMultiple.length > 0) {
                $switchMultiple.each(function () {
                    var $item = $(this);
                    require(['Controls/SwitchMultiple'], function (SwitchMultiple) {
                        new SwitchMultiple($item);
                    });
                });
            }

            var $switchWhyWeBlocks = $('.j-switch-why-we-blocks', context);
            if ($switchWhyWeBlocks.length > 0) {
                $switchWhyWeBlocks.each(function () {
                    var $item = $(this);
                    require(['Controls/SwitchWhyWe'], function (SwitchWhyWe) {
                        new SwitchWhyWe($item);
                    });
                });
            }
            var $switchOurClients = $('.j-switch-our-clients', context);
            if ($switchOurClients.length > 0) {
                $switchOurClients.each(function () {
                    var $item = $(this);
                    require(['Controls/SwitchOurClients'], function (SwitchOurClients) {
                        new SwitchOurClients($item);
                    });
                });
            }

            startSpoiler(context);

            var $spoilerColor = $('.j-spoiler-color', context);
            if ($spoilerColor.length > 0) {
                $spoilerColor.each(function () {
                    var $item = $(this);
                    require(['Controls/SpoilerColor'], function (SpoilerColor) {
                        new SpoilerColor($item);
                    });
                });
            }
            var $actionColor = $('.j-action-color', context);
            if ($actionColor.length > 0) {
                $actionColor.each(function () {
                    var $item = $(this);
                    require(['Controls/ActionColor'], function (ActionColor) {
                        new ActionColor($item);
                    });
                });
            }

            var inputFile = $('.about-tasks').find('.form-file');
            if(inputFile.length) {
                var inputSelector = inputFile.find('.form-file__file');
                var fileCaptionPlace = inputFile.find('.form-file__selected');


                inputSelector.on('change', function() {
                    var $this = $(this);
                    fileCaptionPlace.text($this.val());
                });

            }

            var $responsiveTbl = $('.j-responsive-tbl', context);
            if ($responsiveTbl.length > 0) {
                $responsiveTbl.each(function () {
                    var $item = $(this);
                    require(['Controls/Responsive',
                        'Controls/ResponsiveTbl'], function (obResponsive, ResponsiveTbl) {
                        obResponsive.one(['xsmall', 'small'], 'in', function () {
                            new ResponsiveTbl({
                                root: $item,
                                obResponsive: obResponsive
                            });
                        });
                    });
                });
            }

            var $showAll = $('.j-show-all', context);
            if ($showAll.length > 0) {
                $showAll.each(function () {
                    var $item = $(this);
                    require(['Controls/ShowAll'], function (ShowAll) {
                        new ShowAll($item);
                    });
                });
            }

            $('.j-tab').each(function () {
                var item = $(this);
                require(['Controls/SimpleTabs'], function (SimpleTabs) {
                    new SimpleTabs({
                        root: item,
                        tabNav: item.find('.j-tab-nav')
                    });
                });
            });
            var $listAdjust = $('.j-list-adjust', context);
            if ($listAdjust.length > 0) {
                $listAdjust.each(function () {
                    var $item = this;
                    require(['Controls/ListAdjust'], function (ListAdjust) {
                        new ListAdjust({
                            root: $item
                        });
                    });
                });
            }

            /*
             * Слайдеры
             * */
            var $slider2 = $('.j-slider2', context);
            if ($slider2.length > 0) {
                $slider2.each(function () {
                    var $item = $(this);
                    require(['Controls/Slider2'], function (Slider2) {
                        new Slider2($item);
                    });
                });
            }

            var $bxslider = $('.j-bxslider', context);
            if ($bxslider.length > 0) {
                $bxslider.each(function () {
                    var $item = $(this);
                    require(['Controls/BXSlider'], function (BXSlider) {
                        new BXSlider($item);
                    });
                });
            }

            var $sliderLoop = $('.j-slider-loop', context);
            if ($sliderLoop.length > 0) {
                $sliderLoop.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderLoop'], function (SliderLoop) {
                        new SliderLoop($item);
                    });
                });
            }

            var $sliderEvents = $('.j-slider-events', context);
            if ($sliderEvents.length > 0) {
                $sliderEvents.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderEvents', 'flexslider'], function (SliderEvents) {
                        new SliderEvents($item);
                    });
                });
            }

            var $sliderSync = $('.j-slider-sync', context);
            if ($sliderSync.length > 0) {
                $sliderSync.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderSync', 'Controls/ActionColor'], function (SliderSync) {
                        new SliderSync($item);
                    });
                });
            }

            var $sliderGallery = $('.j-slider-gallery', context);
            if ($sliderGallery.length > 0) {
                $sliderGallery.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderGallery'], function (SliderGallery) {
                        new SliderGallery($item);
                    });
                });
            }

            var $sliderPhotoDescription = $('.j-slider-photo-description', context);
            if ($sliderPhotoDescription) {
                $sliderPhotoDescription.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderPhotoDescription'], function (SliderPhotoDescription) {
                        new SliderPhotoDescription($item);
                    });
                });
            }

            var $sliderZebra = $('.j-slider-zebra', context);
            if ($sliderZebra.length > 0) {
                $sliderZebra.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderZebra'], function (SliderZebra) {
                        new SliderZebra($item);
                    });
                });
            }

            var $sliderClients = $('.j-slider-clients', context);
            if ($sliderClients.length > 0) {
                $sliderClients.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderClients'], function (SliderClients) {
                        new SliderClients($item);
                    });
                });
            }

            var $sliderSimilar = $('.j-slider-similar', context);
            if ($sliderSimilar.length > 0) {
                $sliderSimilar.each(function () {
                    var $item = $(this);
                    require(['Controls/SliderSimilar'], function (SliderSimilar) {
                        new SliderSimilar($item);
                    });
                });
            }

            /*
             * UI 444
             * */

            require(['scrollTo'], function () {
                $(document).on('click', '.effect-button__link', function(e) {
                    var link = $(this);
                    $.scrollTo(link.attr('href'), 500);
                });
            });


            startPopups(context);


            var $showTooltip = $(".showTooltip", context);
            if ($showTooltip.length > 0) {
                require(['jqueryTools'], function () {
                    $showTooltip.tooltip();
                });
            }

            var $scrollable = $('.scrollable', context);
            if ($scrollable.length > 0) {
                require(['jquery', 'easing', 'jqueryTools'], function () {
                    $scrollable.scrollable({
                        easing: 'easeOutQuart',
                        speed: 1000,
                        next: '.client-next',
                        prev: '.client-prev',
                        circular: true
                    });
                });
            }
            var $filterSelect = $('.j-filter-select', context);
            if ($filterSelect.length > 0) {
                $filterSelect.each(function () {
                    var $item = $(this);
                    require(['Controls/Filter/FilterSelect'], function (FilterSelect) {
                        new FilterSelect($item);
                        $item.trigger("FilterSelect.init");
                    });
                });
            }

            var $boxOffices = $('.j-box-offices', context);
            if ($boxOffices.length > 0) {
                /*
                 * Коробки
                 * */
                function initializeBoxOffices($boxOffices) {
                    $boxOffices.each(function () {
                        var $item = $(this);
                        require(['Controls/BoxOffices'], function (BoxOffices) {
                            new BoxOffices($item);
                            getInitial($item).resolve();
                            $item.trigger("jBoxOffices.init");
                        });
                    });
                }

                $boxOffices.on('contactBox.init', function () {
                    compositeFinished(function () {
                        initializeBoxOffices($boxOffices);
                    });
                });
            }

            var $boxAbout = $('.j-box-about', context);
            if ($boxAbout.length > 0) {
                $boxAbout.each(function () {
                    var $item = $(this);
                    require(['Controls/BoxAbout'], function (BoxAbout) {
                        new BoxAbout($item);
                    });
                });
            }

            var $boxImg = $('.j-box-img', context);
            if ($boxImg.length > 0) {
                $boxImg.each(function () {
                    var $item = $(this);
                    require(['Controls/BoxImg'], function (BoxImg) {
                        new BoxImg($item);
                    });
                });
            }
            $('.j-box-img-right', context).each(function () {
                var $item = $(this);
                require(['Controls/BoxImgRight'], function (BoxImgRight) {
                    new BoxImgRight($item);
                });
            });

            /*
             * геотаргетинг
             * */

            // feature-23709770 события окна подтверждения
            // var $geoConfirmClose = $('#geo_confirm .close', context);
            // if ($geoConfirmClose.length > 0) {
            //     $geoConfirmClose.on('click', function () {
            //         window.track(['Геотаргетинг', 'Выбор региона', 'Всплывающая плашка (Крестик)', 1]);
            //     });
            // }
            // var $geoConfirmBtn = $('#geo_confirm .confirm-btn', context);
            // if ($geoConfirmBtn.length > 0) {
            //     $geoConfirmBtn.on('click', function () {
            //         window.track(['Геотаргетинг', 'Выбор региона', 'Всплывающая плашка (Кнопка)', 1]);
            //     });
            // }


            var $headerCityListConfirm = $('#header-city-list-confirm', context);
            if ($headerCityListConfirm.length > 0) {
                $headerCityListConfirm.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Всплывающая плашка (Выбор)', 1]);
                });
            }
            var $headerCityStrong = $('.header-city .strong', context);
            if ($headerCityStrong.length > 0) {
                $headerCityStrong.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Верхняя полоска', 1]);
                });
            }
            var $contactRigthBoxContainerCity = $('#contact-right-box-container .city', context);
            if ($contactRigthBoxContainerCity.length > 0) {
                $contactRigthBoxContainerCity.on('click', function () {
                    window.track(['Геотаргетинг', 'Выбор региона', 'Контактный блок', 1]);
                });
            }

            /*
             * Разное
             * */
            var $questionary = $('.j-questionary', context);
            if ($questionary.length > 0) {
                $questionary.each(function () {
                    var $item = $(this);
                    require(['Controls/Questionary'], function (Questionary) {
                        new Questionary($item);
                    });
                });
            }

    var $vizaSlider = $('.j-viza, .j-slider-viza', context);
    if ($vizaSlider.length > 0) {
        $vizaSlider.each(function () {
            var $item = $(this);
            require(['Controls/Viza'], function (Viza) {
                new Viza($item);
            });
        });
    }
    $('.j-screen-floating', context).each(function () {
        var item = $(this);
        require(['Controls/ScreenFloatingBox'], function (ScreenFloatingBox) {
            new ScreenFloatingBox(item);
        });
    });
    var $leaping = $('.j-leaping', context);
    if ($leaping.length > 0) {
        require(["Controls/Leaping"], function (Leaping) {
            $leaping.each(function () {
                new Leaping(this);
            });
        });
    }

    $('.j-phone', context).each(function () {
        var item = $(this);
        require(['Controls/Phone'], function (Phone) {
            new Phone(item);
        });
    });

    $(document).bind("ScreenFloatingShow", function() {
        if($(".header .width").find(".header-offices-cont").length==0) {
            $(".header .width").append($("#header-offices-parent").find(".header-offices-cont").clone());
            $(".header .header-offices-cont .header-offices").removeClass('j-leaping');
            var $shuffleOffices = $('.j-shuffle-offices', context);
            if ($shuffleOffices.size() > 0) {
                require(["Controls/ShuffleOffices"], function (ShuffleOffices) {
                    $shuffleOffices.each(function () {
                        new ShuffleOffices(this);
                    });
                });
            }
        }
    });

            var popoverBlock = $('.popover', context);
            if (popoverBlock.length > 0) {
                popoverBlock.webuiPopover({trigger: 'hover'});
            }
            /*
             * Trash
             */
            if ($('.table-present:not(.j-send-request) td', context)
                    .add('.j-submit', context)
                    .add('.j-submit2', context)
                    .add('.j-file', context)
                    .add('.close-action', context)
                    .add('.why-we-block', context)
                    .add('#userFile', context)
                    .add('.j-print', context).length > 0
            ) {
                require(['trash'], function () {
                    tablePresent();
                });
            }



        });

        Ready.lazyLoadRecived.then(function () {

		  // enable google recaptcha
            require(['Controls/ReCaptchaProvider'], function (ReCaptchaProvider) {
                new ReCaptchaProvider();
            });

            textScrollStart();
            startSelects();

        });

        $(function () {
            $.event.trigger({
                type: "onMainInit",
                initiatorEventType: 'ready',
                contextContainer: document
            });
        });
        if (window.frameCacheVars !== undefined) {
            BX.addCustomEvent("onFrameDataReceived", function () {
                //debugger;
            });
        }
        $(document).on("lazyLoadBlockUpdate", function (event) {
            $.event.trigger({
                type: "onMainInit",
                initiatorEventType: 'lazyLoadBlockUpdate',
                contextName: event.contextName,
                contextContainer: event.contextContainer
            });
        });

        $(document).on('OnManualOfficeSelect', function (e, data) {
            var
                officeName = data.officeName;

            if (officeName == '')
                officeName = data.officeId;

            window.track(['Клик', 'Ссылка выберите офис', officeName]);
        });

        $(document).on('onDefferedCopyComplete', function (e, data) {
            var context = e.contextContainer || document;
            startSwiper();
            startOwlCarousel(context);
            formStart(context);
            startSpoiler(context);
            startPopups(context);
            textScrollStart();
            startSelects();
        });




        function jivo_onOpen() {
            var tracker = ga.getAll()[0];
            var gCliendId = tracker.get('clientId');
            jivo_api.setCustomData([
                {
                    title: 'gCliendId',
                    content: gCliendId,
                }
            ]);
        }

        require(['Controls/UtmLog'], function (UtmLog) {
            (new UtmLog()).execute();
        });
        /*
        * Замена текста из параметров в url
        * */
        require(['Controls/ContentUrlReplace'], function (ContentUrlReplace) {
            (new ContentUrlReplace()).execute();
        });

        $(document).on('form.result.popup.open', function (event, data) {
          if (typeof sendGoal === "function") sendGoal('form_send');
        });

        $(document).on('copy', function (event) {
            const bodyEl = document.getElementsByTagName('body');
            if(!bodyEl[0].dataset.authorized || bodyEl[0].dataset.authorized !== 'Y') {
                let souText = '<br>Источник: ';
                let souLink = document.location.href;
                let choose = window.getSelection();
                let copyText =  choose + souText + souLink;
                let copyEl = document.createElement('div');
                copyEl.style.position = 'absolute';
                copyEl.style.left = '-10000px';
                bodyEl[0].appendChild(copyEl);
                copyEl.innerHTML = copyText;
                choose.selectAllChildren(copyEl);
                window.setTimeout(function(){
                    bodyEl[0].removeChild(copyEl);
                },0);
            }
        });

        window.onload = function() {
            lazyLoadsInit();
            // Прячем последние цифры телефона в указанных городах

            var hidePhones = function(hidePhoneList){
              for(var i = 0; i < hidePhoneList.length; i++){
                var currentItem = hidePhoneList[i];
                currentItem.classList.add('slice_phone_number');

                var sliceButton = document.createElement('span');
                sliceButton.classList.add('show_slice_phone');
                sliceButton.textContent = 'показать телефон';
                currentItem.append(sliceButton);

                currentItem.addEventListener('click', function(e){
                  var sliceButtonCurrent = this.querySelector('.show_slice_phone');
                  if(sliceButtonCurrent){
                    e.preventDefault();

                    this.classList.add('visible');
                    sliceButtonCurrent.remove();
                  }
                });
              }
            };

            var hidePhoneRoot = document.querySelector('.slice-phone-active');
            if(hidePhoneRoot){
              var hidePhoneList = document.querySelectorAll('.footer-contacts .box-phone-href, .phone, li.box-office-phone');
              hidePhones(hidePhoneList);
            }

            //удаляем теги ym-measure
            var parent = document.getElementById("LHE_iframe_PROPERTYDETAILTEXT0");
			if (parent) {
				var elements = parent.getElementsByTagName("ym-measure");
				for(var i=0;i<=elements.length-1;i++){
					elements[i].parentNode.removeChild(elements[i]);
				}
			}

            $(document).on('jFormPopup.init', function (event) {
                let btnContext = event.target;
                let formSalt = btnContext.dataset.saltForm;
                let formBtn = btnContext.dataset.btn;
                let searchParams = new URLSearchParams(window.location.search);
                if (!searchParams.has('formresult') && searchParams.has('form-popup-open') && formSalt === searchParams.get('form-popup-open') && $('body').data('modal-open') !== 'true') {
                    $(formBtn).first().click();
                }
            });
        };

	return true;
    })
}
;
